import React from 'react';
import PropTypes from 'prop-types';

const HeroContainer = props => (
  <React.Fragment>
    <style>
      {`
        .hero-module-container {
          background-image: url(${props.images.mobile});
        }

        @media (min-width: 48em) {
          .hero-module-container {
            background-image: url(${props.images.desktop});
          }
        }
      `}
    </style>
    <section className="hero hero-module-container">{props.children}</section>
  </React.Fragment>
);

HeroContainer.propTypes = {
  images: PropTypes.shape({
    mobile: PropTypes.string.isRequired,
    desktop: PropTypes.string.isRequired
  }).isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};

export default HeroContainer;
